import { useQuery } from '@tanstack/react-query';

import { Currency } from '@/constants';
import { reownModal } from '@/networks/evm/components/Wagmi/WagmiWrapper';
import { convertStringToBigInt } from '@/utils';

import { getSolanaNetwork } from '../utils/rpc';

export const useSolanaBalance = (address: string | null, isConnected: boolean) => {
  const network = getSolanaNetwork();

  return useQuery({
    queryKey: ['solana-balance', address, network.id],
    queryFn: async () => {
      if (!address || !reownModal) {
        return 0n;
      }

      const result = await reownModal.updateNativeBalance(address, network.id, 'solana');

      if (!result?.balance) {
        return 0n;
      }

      return convertStringToBigInt(result.balance, Currency.SOL);
    },
    enabled: !!address && isConnected,
    refetchInterval: 10_000,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    retry: 2,
  });
};
